import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter } from 'lucide-react';
import { clinicInfo } from '../mockData';
import logo from "../assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <img
              src={logo}
              alt="V Derma"
              className="h-16 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              {clinicInfo.tagline}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-cyan-400">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-cyan-400">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <a href={`tel:${clinicInfo.phone}`} className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  {clinicInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <a href={`mailto:${clinicInfo.email}`} className="text-gray-300 hover:text-cyan-400 transition-colors text-sm">
                  {clinicInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">{clinicInfo.address}</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-cyan-400">Working Hours</h3>
            <ul className="space-y-2">
              <li className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <div className="text-gray-300 text-sm">
                  <p>{clinicInfo.workingHours.weekdays}</p>
                  <p className="mt-1">{clinicInfo.workingHours.saturday}</p>
                  <p className="mt-1 text-red-400">{clinicInfo.workingHours.sunday}</p>
                </div>
              </li>
            </ul>
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-gray-300 hover:text-cyan-400 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-cyan-400 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              {/* <a href="#" className="text-gray-300 hover:text-cyan-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a> */}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6">
  <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-gray-400">
    
    {/* Center Text */}
    <p className="text-center md:text-left w-full md:w-auto">
      © {new Date().getFullYear()} V Derma Skin Clinic. All rights reserved.
    </p>

    {/* Right Side */}
    {/* <p className="text-center md:text-right w-full md:w-auto">
      Developed by{" "}
      <a href='https://x7ittechologies.com' target='blank'><span className="text-orange-400 font-medium hover:underline cursor-pointer">
        X7 IT Technologies
      </span></a>
    </p> */}

  </div>
</div>

      </div>
    </footer>
  );
};

export default Footer;